import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AuthService } from '@bilancio/auth';
import {
    AuthSelectors,
    CoreActions,
    SuperStore,
    TsStudioSelectors
} from '@bilancio/root-store';
import { TourTemplateService } from '../tour-template/tour-template.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'app-user-context-menu'
    },
    selector: 'app-user-context-menu',
    styleUrls: ['user-context-menu.component.scss'],
    templateUrl: 'user-context-menu.component.html',
    standalone: false
})
export class UserContextMenuComponent {
    /** Username to show in header */
    @Input() username: string;

    @Input() isAdmin: boolean;

    /** Whether drawer should be shown */
    @Input() isVisible = false;
    readonly descrUtente =
        'Puoi accedere alle informazioni del tuo profilo. Se sei un utente amministratore, puoi accedere anche ad altre funzionalità di gestione.';
    isIntegration$ = this.store.select(TsStudioSelectors.getIsIntegration);
    isLybera$ = this.store.select(AuthSelectors.getIsLyberaStudio);
    isViaLiberaDeposit$ = this.store.select(
        AuthSelectors.getIsViaLiberaDeposit
    );

    constructor(
        readonly authService: AuthService,
        private readonly store: SuperStore,
        readonly tour: TourTemplateService
    ) {}

    hideDrawer(): void {
        this.isVisible = false;
    }

    /** Show or hide drawer */
    toggleDrawer(): void {
        this.isVisible = !this.isVisible;
    }

    doLogout() {
        this.authService.doLogout();
        this.store.dispatch(CoreActions.cleanCoreState());
    }
}
